import { Col, Container, Row } from "react-bootstrap";
import { Link, Navigate } from "react-router-dom";
import { useReportingPeriodScreen } from "./hooks";
import ReportingPeriodCard from "../ReportingPeriodCard/ReportingPeriodCard";
import PerformancePreviewCard from "../PerformancePreviewCard/PerformancePreviewCard";
import { H2 } from "../ui/Typography";
import { Button, NavigationFooter } from "./styles";

function ReportingPeriod() {
  const { redirectHome, continueUrl, continuteButtonDisabled } =
    useReportingPeriodScreen();

  if (redirectHome) {
    return <Navigate to="/" />;
  }
  return (
    <Container>
      <Row>
        <Col>
          <H2>Reporting period and performance review</H2>
        </Col>
      </Row>

      <ReportingPeriodCard />

      <PerformancePreviewCard />

      <NavigationFooter>
        <Link to="/">
          <Button secondary>Back</Button>
        </Link>
        <Link to={continueUrl}>
          <Button disabled={continuteButtonDisabled}>Continue</Button>
        </Link>
      </NavigationFooter>
    </Container>
  );
}

export default ReportingPeriod;
